<!--~
  ~ Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
@if (command.hasCustomUi()) {
    <ng-template csWidgetCustomUi></ng-template>
} @else {
    @if (shouldDisplay$ | async) {
        @if (isInBottomSheet) {
            <button
                mat-icon-button
                (click)='invoke()'
                [disabled]='shouldDisable$ | async'
                [csActiveTool]='commandName'
                [deactivate$]='deactivate$'
                (deactivated)='toolDeactivated()'
                [matMenuTriggerFor]='(hasMenu$ | async) ? widgetMenu : null'
                [matTooltip]='label'
                [attr.aria-label]='label'>
                <mat-icon [svgIcon]='icon'></mat-icon>
            </button>
        } @else {
            <button
                mat-icon-button
                (click)='invoke()'
                [disabled]='shouldDisable$ | async'
                [csActiveTool]='commandName'
                [deactivate$]='deactivate$'
                (deactivated)='toolDeactivated()'
                [matMenuTriggerFor]='(hasMenu$ | async) ? widgetMenu : null'
                matTooltip="{{ label }}{{ hotKey ? ' (' + hotKey + ')' : '' }}"
                [attr.aria-label]='label'>
                <mat-icon [svgIcon]='icon'></mat-icon>
            </button>
        }
    }
}

<mat-menu #widgetMenu (closed)='menuClosed($event)'>
    <ng-template matMenuContent>
        @for (menuItem of widgetMenuItems$ | async; track menuItem) {
            <button mat-menu-item (click)='menuItem.action()'>
                @if (menuItem.icon) {
                    <mat-icon [svgIcon]='menuItem.icon'></mat-icon>
                }
                <span>{{ menuItem.label }}</span>
            </button>
        }
    </ng-template>
</mat-menu>